{
  "back": "Назад",
  "form": "Форма",
  "purposeTitle": "Яка мета вашої зупинки?",
  "appointmentInfoTitle": "Інформація про призначення",
  "appointmentInfoHint": "Обов'язково заповніть це поле, якщо у вас є призначення.",
  "checkInDetailsTitle": "Деталі реєстрації",
  "checkInDetailsHint": "Додаткова інформація про ваш візит.",
  "driverPhoneLabel": "Номер телефону водія",
  "activateWhatsAppTitle": "Активувати повідомлення WhatsApp",
  "activateWhatsAppBody": "Щоб спілкуватися зі складом, відповідайте «OK» на перше повідомлення WhatsApp від нас.",
  "whatsappDelayBanner": "Перше повідомлення WhatsApp може надійти з затримкою до однієї хвилини.",
  "notesLabel": "Примітки",
  "notesPlaceholder": "Особливі інструкції або примітки для об'єкта?",
  "addNoteToWarehouse": "Додати примітку для складу",
  "verifyAndCheckIn": "Перевірити та зареєструватись",
  "completeCheckIn": "Завершити реєстрацію",
  "visitGroupInbound": "Вхідний",
  "visitGroupOutbound": "Вихідний",
  "visitGroupBoth": "Вхідний та вихідний",
  "visitUnloadTruck": "Розвантажити мою вантажівку",
  "visitDropTrailer": "Залишити мій причіп або контейнер",
  "visitLoadTruck": "Завантажити мою вантажівку",
  "visitHookTrailer": "Причепити причіп або контейнер",
  "visitUnloadLoad": "Розвантажити та завантажити мою вантажівку",
  "visitDropHook": "Залишити та причепити причіп або контейнер",
  "containerTrailer": "Причіп",
  "containerContainer": "Контейнер",
  "containerOversized": "Негабаритний",
  "containerOther": "Інше",
  "defaultReferenceName": "Номер замовлення на купівлю",
  "identifierSuffix": "{reference} або номер підтвердження",
  "licenseOrDotRequired": "Будь ласка, вкажіть номерний знак або номер DOT",
  "appointmentNotFound": "Нам не вдалось знайти ваше призначення",
  "referenceNotFound": "Відповідний запис не знайдено. Довідкові номери чутливі до регістру.",
  "referenceCaseSensitiveHint": "Довідковий номер чутливий до регістру",
  "messaging": {
    "whatsappFailedTitle": "Не вдалося надіслати повідомлення WhatsApp",
    "smsFailedTitle": "Не вдалося надіслати SMS-повідомлення",
    "whatsappFailedBody": "Нам не вдалося надіслати повідомлення на номер {displayPhone}. <br /><br /> Якщо ви раніше відписались, будь ласка, надішліть START на номер <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a>, щоб знову отримувати повідомлення від цього складу.",
    "smsFailedBody": "Нам не вдалося надіслати повідомлення на номер {displayPhone}. <br /><br /> Якщо ви раніше відписались, будь ласка, надішліть START на номер <a href='{smsUrl}'>{senderPhone}</a>, щоб знову отримувати SMS-повідомлення від цього складу.",
    "fallbackPhone": "вказаний номер телефону"
  }
}
